import { render, staticRenderFns } from "./404.vue?vue&type=template&id=43bd2e86&scoped=true&"
import script from "./404.js?vue&type=script&lang=js&"
export * from "./404.js?vue&type=script&lang=js&"
import style0 from "./404.scss?vue&type=style&index=0&id=43bd2e86&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "43bd2e86",
  null
  
)

export default component.exports